<div class="sz-hf-grid" [class.sz-hf-grid--wrap]="layout() === 'wrap'">
  @for (zone of zones(); track zone.key) {
    <button
      type="button"
      class="sz-hf-grid__cell"
      [class.sz-hf-grid__cell--active]="zone.active"
      [class.sz-hf-grid__cell--bad]="isBad(zone.key)"
      [attr.data-zone]="zone.key"
      [disabled]="disabled()"
      (click)="onClick(zone.key)">
      <span class="sz-hf-grid__label">{{ zone.key }}</span>
      <span class="sz-hf-grid__value">{{ zone.value }}</span>
    </button>
  }
  @if (time(); as t) {
    <button
      type="button"
      class="sz-hf-grid__cell sz-hf-grid__cell--time"
      [class.sz-hf-grid__cell--invalid]="t.invalid"
      data-zone="TIME"
      [disabled]="disabled()"
      (click)="onTimeClick()">
      <span class="sz-hf-grid__label">{{ t.label }}</span>
      <span class="sz-hf-grid__value" [class.sz-hf-grid__value--empty]="t.invalid">{{ t.value }}</span>
    </button>
  }
</div>
